import React from "react";
import PropTypes from "prop-types";
import InfoInline from "./InfoInline";
import { InfoField } from "../style";

export default function getRecognitionRender(
  recognitionId,
  advisors = [],
  thirdParty,
  includeAdvisorInfo
) {
  switch (recognitionId) {
    case "10": {
      return (
        <>
          <InfoField wordBreakOnly>
            Account Advisor(s) name(s) and address(es)
          </InfoField>
          <InfoField wordBreakOnly>Account name</InfoField>
        </>
      );
    }
    case "20": {
      return (
        <>
          {includeAdvisorInfo && (
            <InfoField wordBreakOnly>
              Account Advisor(s) name(s) and address(es)
            </InfoField>
          )}
          <InfoField wordBreakOnly>Account name</InfoField>
          <InfoInline title="Third Party:" value={thirdParty} />
        </>
      );
    }
    case "30": {
      return "Anonymous";
    }
    case "40": {
      return "Account name";
    }
    default: {
      return null;
    }
  }
}

getRecognitionRender.propTypes = {
  recognitionId: PropTypes.string.isRequired,
  advisors: PropTypes.array,
  thirdParty: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.elementType
  ]),
  includeAdvisorInfo: PropTypes.bool
};
